<div class="container">
    <h1>All Roles</h1>

    <a class="btn btn-primary mb-3" style="width:auto" href="/create_role">Add New Role</a>


    @if(userRoles.length > 0)
    {
    <ng-container *ngFor="let role of userRoles">
        <div class="card text-bg-secondary mb-3 role-card mb-3">
            <div class="card-header">
                Role Id : {{role.id}}
            </div>
            <div class="card-body">
                <h5 class="card-title">
                    {{role.name}}
                </h5>
                <div>
                    {{role.description}}
                </div>
            </div>
            <div class="card-footer">
                <form name="deleteRole" (ngSubmit)="deleteRole(role.id)" #deleteRoleForm="ngForm" method="post">
                    <a [href]="'/edit_role?roleId=' + role.id + '&roleName=' + role.name + '&description=' + role.description" class="btn btn-primary me-2">Edit</a>

                    <span id="confirmDeleteSpan_{{role.id}}" class="d-none">
                        <span>Are you sure you want to Delete?</span>
                        <button type="submit" class="btn btn-danger mx-2">Yes</button>
                        <button type="button" class="btn btn-primary" (click)="confirmDelete(role.id, false)">No</button>
                    </span>
                    <span id="deleteSpan_{{role.id}}">
                        <button type="button" class="btn btn-danger" (click)="confirmDelete(role.id, true)">Delete</button>
                    </span>
                </form>
            </div>
        </div>
    </ng-container>
    }
    @else
    {
    <div class="card">
        <div class="card-header">
            No roles created yet
        </div>
        <div class="card-body">
            <h5 class="card-title">
                Use the button below to create a role
            </h5>
            <a class="btn btn-primary" href="/create_role">Create New Role</a>
        </div>
    </div>
    }
</div>
